module.exports = __webpack_public_path__ + "static/media/logo.607f29a9.jpg";